@if (device.device(); as currentDevice) 
    { @switch (currentDevice) 
        { @case ('desktop') 
            {
                <!-- ===================================================== -->
                <!-- DESKTOP -->
                <!-- ===================================================== -->
                <header class="navbar navbar--desktop">
                    <div class="navbar__left">
                        <img class="navbar__logo" src="assets/icon/new_icon/logo-explore.svg" alt="Explore Logo" />

                        <nav class="navbar__main-nav" aria-label="Main navigation">
                        @if (isConfig()) {
                            <app-autocomplete
                                class="navbar__org-select"
                                [data]="orgOptions()"
                                [ngModel]="selectedOrgLabel()"
                                [revertOnBlur]="true"
                                [dropdownWidth]="'16rem'"
                                placeholder="{{ 'NAV_BAR.ORGANIZATION' | translate }}"
                                (selected)="onOrgSelected($event)"
                                data-attr="navbar-org-select">
                            </app-autocomplete>
                        }

                        <button type="button" class="nav-btn" [class.nav-btn--active]="isOperations()" (click)="navigateToArea()">
                            <span class="icon_16 icon_16--markers"></span>
                            <span>{{ 'NAV_BAR.OPERATIONS' | translate }}</span>
                        </button>

                        @if (canSeeConfig) {
                            <button type="button" class="nav-btn" [class.nav-btn--active]="isConfig()" (click)="navigateToConfig()">
                                <span class="icon_16 icon_16--settings"></span>
                                <span>{{ 'NAV_BAR.CONFIGURATION' | translate }}</span>
                            </button>
                        }
                        </nav>
                    </div>

                    <div class="navbar__right">
                        <ng-container [ngTemplateOutlet]="profileNavBar"></ng-container>

                        <!-- <button type="button" class="icon-btn" aria-label="Help">?</button> -->
                        <button type="button" (click)="navigateToOurProducts()" class="icon-btn tooltip-btn tooltip-btn--right" [class.icon-btn--active]="isOurProducts()" [attr.data-tooltip]="'NAV_BAR.OUR_PRODUCTS' | translate">
                            <img class="icon_24" src="assets/icon/new_icon/floating_buttons.svg" [attr.alt]="'NAV_BAR.OUR_PRODUCTS' | translate" />
                        </button>
                        <button type="button" matBadge="" class="icon-btn icon-btn--disabled tooltip-btn tooltip-btn--right" disabled [attr.data-tooltip]="'NAV_BAR.NOTIFICATIONS' | translate">
                            <img class="icon_24" src="assets/icon/new_icon/notification.svg" [attr.alt]="'NAV_BAR.NOTIFICATIONS' | translate" />
                        </button>
                    </div>
                </header>
            } 
            @case ('mobile') 
            {
                <!-- ===================================================== -->
                <!-- MOBILE -->
                <!-- ===================================================== -->

                <!-- Mobile close -->
                <header class="navbar navbar--compact">
                    <img class="navbar__logo" src="assets/icon/new_icon/logo-explore.svg" alt="Explore Logo" />

                    @if (isConfig()) {
                        <app-autocomplete
                            class="navbar__org-select"
                            [data]="orgOptions()"
                            [ngModel]="selectedOrgLabel()"
                            [revertOnBlur]="true"
                            [dropdownWidth]="'16rem'"
                            placeholder="{{ 'NAV_BAR.ORGANIZATION' | translate }}"
                            (selected)="onOrgSelected($event)"
                            data-attr="navbar-org-select-mobile">
                        </app-autocomplete>
                    }

                    <button
                        type="button"
                        class="menu-toggle-btn"
                        [attr.aria-label]="menuOpen() ? 'Close menu' : 'Open menu'"
                        (click)="toggleMenu()"
                    >
                        @if(menuOpen()) 
                        {
                            <img slot="icon-left" src="./../../assets/icon/new_icon/close.svg" />
                        }
                        @else 
                        {
                            <img slot="icon-left" src="./../../assets/icon/new_icon/vector.svg" />
                        }
                    </button>
                </header>

                @if (menuOpen()) 
                {
                    <!-- Mobile open -->
                    <section class="overlay-menu overlay-menu--mobile">
                    <div class="overlay-menu__body">
                        <div class="overlay-menu__center">
                            <button type="button" class="nav-btn" [class.nav-btn--active]="isOperations()" (click)="navigateToArea()">
                                <span class="icon_16 icon_16--markers"></span>
                                <span>{{ 'NAV_BAR.OPERATIONS' | translate }}</span>
                            </button>

                            @if (canSeeConfig) {
                                <button type="button" class="nav-btn" [class.nav-btn--active]="isConfig()" (click)="navigateToConfig()">
                                    <span class="icon_16 icon_16--settings"></span>
                                    <span>{{ 'NAV_BAR.CONFIGURATION' | translate }}</span>
                                </button>
                            }
                        </div>

                        <div class="overlay-menu__footer">
                        <hr class="overlay-menu__divider" />

                        <ng-container [ngTemplateOutlet]="profileNavBar"></ng-container>

                        <button type="button" matBadge="7" class="icon-btn" [attr.data-tooltip]="'NAV_BAR.NOTIFICATIONS' | translate">
                            <img class="icon_24" src="assets/icon/new_icon/notification.svg" alt="{{'NAV_BAR.NOTIFICATIONS' | translate}}" />
                            <span>{{'NAV_BAR.NOTIFICATIONS' | translate}}</span>
                        </button>

                        <button type="button" (click)="navigateToOurProducts()" class="icon-btn" [class.icon-btn--active]="isOurProducts()" [attr.data-tooltip]="'NAV_BAR.OUR_PRODUCTS' | translate">
                            <img class="icon_24" src="assets/icon/new_icon/floating_buttons.svg" alt="{{'NAV_BAR.OUR_PRODUCTS' | translate}}" />
                            <span>{{'NAV_BAR.OUR_PRODUCTS' | translate}}</span>
                        </button>
                        </div>
                    </div>
                    </section>
                } 
            } 
        } 
    }


<ng-template #profileNavBar>
    <button type="button" class="profile-btn" [class.profile-btn--active]="profileMenuOpen"
        cdkMenuItem [cdkMenuTriggerFor]="profileMenu" (click)="onProfileMenu()">
        <span class="avatar">{{userProfile()?.firstName?.charAt(0)}}</span>
        <span>{{userProfile()?.firstName}} {{userProfile()?.lastName}}</span>
        <span class="icon_16 icon_profile--markers"></span>
    </button>

    <ng-template #profileMenu>
        <div class="menu-tab" cdkMenu [style.min-width]="profileBtnWidth()">
            <button class="menu-tab-item" cdkMenuItem (click)="navigateToProfile()">
                <img class="icon_24" src="assets/icon/new_icon/profil.svg" alt="Configuration Icon" />
                {{'NAV_BAR.PROFILE' | translate}}
            </button>
            <button class="menu-tab-item" cdkMenuItem (click)="isPopupOpen = true">
                @if(languageSelected === 'en') 
                {
                    <img class="icon_24" src="assets/icon/new_icon/english_flag.svg" alt="Language Icon" />
                }
                @if(languageSelected === 'fr') 
                {
                    <img class="icon_24" src="assets/icon/new_icon/french_flag.svg" alt="Language Icon" />
                }
                @if(languageSelected === 'es') 
                {
                    <img class="icon_24" src="assets/icon/new_icon/spanish_flag.svg" alt="Language Icon" />
                }
                {{'NAV_BAR.LANGUE' | translate}}
            </button>
            <button class="menu-tab-item" cdkMenuItem (click)="logout()">
                <img class="icon_24" src="assets/icon/new_icon/logout.svg" alt="Log out Icon" />
                {{'NAV_BAR.DECONNEXION' | translate}}
            </button>
        </div>
    </ng-template>
</ng-template>  

@if (isPopupOpen) {
<app-popup
    title="{{'NAV_BAR.LANGUE' | translate}}"
    [isOpen]="isPopupOpen"
    size="xsmall"
    variant="secondary"
    color="mint"
    (closed)="closePopup()"
    >
    <app-radiobox
        [options]="languages"
        size="medium"
        color="mint"
        iconPosition="left"
        [(ngModel)]="languageSelected">

        <!-- Une ng-template par option avec appRadioIcon="valeur" -->
        <ng-template appRadioIcon="en">
            <img src="assets/icon/new_icon/english_flag.svg" width="20" height="20" alt="English">
        </ng-template>

        <ng-template appRadioIcon="fr">
            <img src="assets/icon/new_icon/french_flag.svg" width="20" height="20" alt="Français">
        </ng-template>

        <ng-template appRadioIcon="es">
            <img src="assets/icon/new_icon/spanish_flag.svg" width="20" height="20" alt="Español">
        </ng-template>

    </app-radiobox>

    <ng-container slot="footer">
        <app-button label="{{'NAV_BAR.CANCEL' | translate}}"    variant="secondary" color="mint" (click)="closePopup()" />
        <app-button label="{{'NAV_BAR.CONFIRM' | translate}}"  variant="primary"   color="mint" (click)="changerLangue()" />
    </ng-container>
</app-popup>
}